import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "wynridge_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const choose = (value) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ value, at: new Date().toISOString() }));
    } catch (e) {
      /* ignore storage errors */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie" role="dialog" aria-live="polite" aria-label="Cookie consent">
      <div className="cookie-inner">
        <p className="cookie-text">
          We use cookies to operate this site and understand how it's used. By clicking
          &ldquo;Accept&rdquo;, you consent to our use of cookies. You can decline non-essential
          cookies at any time. Learn more in our <Link to="/privacy">Privacy Policy</Link>.
        </p>
        <div className="cookie-actions">
          <button className="pill cookie-decline" onClick={() => choose("declined")}>Decline</button>
          <button className="pill cookie-accept" onClick={() => choose("accepted")}>Accept</button>
        </div>
      </div>
    </div>
  );
}
